<template>
  <component :is="illustrations[illustrationType]" />
</template>

<script setup>
import { shallowRef } from 'vue'
import * as IllustrationModule from './illustrations/index'

defineProps({
  illustrationType: {
    type: String,
    default: () => null
  }
});

const illustrations = shallowRef(IllustrationModule);
</script>
